module.exports = __webpack_public_path__ + "1_0_60/img/tasks_chat_back.6355777f.svg";